"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProposalMemberSubset = void 0;
const interfaces_1 = require("@buildcore/interfaces");
const Subset_1 = require("../Subset");
/**
 * Proposal Member subset
 */
class ProposalMemberSubset extends Subset_1.SubsetClass {
    constructor() {
        super(...arguments);
        /**
         * TODO
         *
         * @param voted
         * @param startAfter
         * @returns
         */
        this.getVotingMembersLive = (voted, startAfter) => {
            const params = {
                dataset: this.dataset,
                setId: this.setId,
                subset: this.subset,
                fieldName: ['voted'],
                fieldValue: [voted],
                operator: [interfaces_1.Opr.EQUAL],
                startAfter,
                orderBy: ['createdOn'],
                orderByDir: ['desc'],
            };
            return this.getManyAdvancedLive(params);
        };
    }
}
exports.ProposalMemberSubset = ProposalMemberSubset;
